<template>
  <div>
    <b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
        title="Edit Organic Social Media Plan" class="modal-edit-deliverable" @hide="editOrganicSocialModalPlanHidden"
        @shown="pushRoute" @hidden="removeRoute">
        <EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
          :namespace="namespace" />
    </b-modal>
    <RelatedDeliverablesSchedule v-if="systemSettingsReady" :parentDeliverableId="parentDeliverableId" :namespace="namespace"
      :tabTitle="'scheduled-content'"  :key="'sms-rds'" ref="refRelatedDeliverablesSchedule" :showLogo="true"/>
  </div>
</template>
<script>
import RelatedDeliverablesSchedule from "../components/deliverables/RelatedDeliverablesSocialMediaSchedule";
import EditOrganicSocialMediaPlanModal from "../components/deliverables/EditOrganicSocialMediaPlanModal";

import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
    	parentDeliverableId:null,
    	namespace:"",
      expandAll: !this.isMobile(),
      systemSettingsReady: false,
      namespace:"",
    }
  },
  computed: {
  		...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allCustomFields (state, getters) {
  	    return getters[this.namespace + 'allCustomFields']
  	  },
  	  allUsers (state, getters) {
  	    return getters['allUsers']
  	  },
  	  systemSettings (state, getters) {
  	    return getters['systemSettings']
  	  },
        deliverableDetail(state, getters) {
          return getters[this.namespace + 'deliverableDetail']
        },
  	}),
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    EditOrganicSocialMediaPlanModal,
  	RelatedDeliverablesSchedule,
  },
  methods: {
  	...mapActions({
  	  fetchSystemSettings (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchSystemSettings', payload)
  	  },
  	}),
    editOrganicSocialModalPlanHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
    pushRoute() {
			if(this.isListView) {
				history.pushState(
					{},
					null,
					'/social-media/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
				)
			} else {
				history.pushState(
					{},
					null,
					'/social-media-grouped/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ?  ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
				)
			}
			let currentTitle = document.title.match(/\(\d+\)\s/g);
			if(!currentTitle) {
				document.title = this.deliverableDetail.title;
			} else {
				document.title = currentTitle[0] + this.deliverableDetail.title;
			}
		},
		removeRoute() {
			history.pushState(
				{},
				null,
				this.$router.currentRoute.matched[0].path
			);
		},
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    },
    checkSystemSettingsReady(){
      if(this.systemSettings.publish_statuses){
        this.systemSettingsReady = true;


      	this.$nextTick(() => {
          // force resize of schedule
          if (this.$refs.refRelatedDeliverablesSchedule) {
        	  this.$refs.refRelatedDeliverablesSchedule.$refs.refSocialScheduleCalendar.forceResizeCalender();
        	  // this.$refs.refRelatedDeliverablesSchedule.$refs.refHeaderControls.applyFilter();
        	}
        });

      } else {
        this.systemSettingsReady = false;
      }
    },
  },
  mounted(){
    document.body.classList.add("social-media");



  },
  created(){
    this.fetchSystemSettings();
    this.checkSystemSettingsReady();
  },
  watch:{
		systemSettings (to, from){
			console.log("systemSettings changed");
      this.checkSystemSettingsReady();
		}
	}
}
</script>
